// libs
import React, { useCallback } from 'react';
import createStateContext from 'react-use/lib/factory/createStateContext';

import { cn } from '@lyearn/style';
// components
import Touchable from '@/components/Touchable';

import { ScorecardFragment } from '../../../graphql/fragments/generated/Scorecard';
import AverageScore from '../AverageScore';
import Name from '../Name';
import QuestionsMarked from '../QuestionsMarked';
import SkillName from '../SkillName';
import TotalQuestions from '../TotalQuestions';
// types

const [useScorecard, ScorecardProvider] = createStateContext<ScorecardFragment | undefined | null>(
  null,
);

const ScorecardP: React.FC<{
  children: React.ReactNode;
  className: string;
  scorecard: ScorecardFragment;
  onClick?: (scorecardId: string) => void;
}> = (props) => {
  const { scorecard, className, children, onClick } = props;

  const { id } = scorecard;

  const onScorecardClick = useCallback(() => {
    if (id && onClick) {
      onClick(id);
    }
  }, [onClick, id]);

  return (
    <ScorecardProvider initialValue={scorecard}>
      <Touchable
        className={cn(className, onClick ? 'cursor-pointer' : '')}
        onPress={onScorecardClick}>
        {children}
      </Touchable>
    </ScorecardProvider>
  );
};

const Scorecard = {
  Name,
  TotalQuestions,
  SkillName,
  AverageScore,
  QuestionsMarked,
  Provider: ScorecardP,
};

export default Scorecard;
export { useScorecard };
